<div class="modal-header">
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
  <h4 class="modal-title">Choices</h4>
</div>

<div class="form-group modal-body" style="min-height: 400px;">
  <div class="container-fluid">

    <div class="row">
      <div class="col-md-12">
        <dx-data-grid biz-grid [selection]='{ mode: "none" }' [dataSource]='choices' [bizSetGroupPanel]="false"
          [bizSetColumnChooser]="false" [bizSetAllowColumnReordering]="false" (onInitNewRow)="onInitNewRow($event)"
          (onRowInserted)="onRowInserted($event)" (onRowUpdated)="onRowUpdated($event)" (onRowRemoved)="onRowRemoved($event)">

          <dxo-editing mode="row" [allowUpdating]="true" [allowAdding]="true" [allowDeleting]="true"></dxo-editing>

          <dxo-group-panel [visible]="false"></dxo-group-panel>

          <dxi-column dataField="Value" caption="Value" dataType="string">
            <dxi-validation-rule type="required"></dxi-validation-rule>
          </dxi-column>

          <dxi-column dataField="DisplayValue" caption="Display value" dataType="string">
            <dxi-validation-rule type="required"></dxi-validation-rule>
          </dxi-column>

          <dxi-column dataField="SortOrder" caption="Order" dataType="number" width="100" sortOrder="asc">
            <dxi-validation-rule type="required"></dxi-validation-rule>
          </dxi-column>

          <dxi-column dataField="IsDefault" caption="Default" dataType="boolean" width="100">
          </dxi-column>

        </dx-data-grid>
      </div>
    </div>

  </div>
</div>

<div class="modal-footer">
  <div class="text-center">
    <button type="submit" style="min-width: 12rem;" class="btn btn-primary" (click)="ok()">OK</button>
    <button type="button" style="min-width: 12rem;" class="btn btn-default" (click)="cancel()">Cancel</button>
  </div>
</div>
